import React, { useEffect, useState } from "react";
import "./Myprofile.css";
import arrow from "../../assets/arrow.png";
import { ApiCall, Colors, FilterApi, Web_url } from "../../common/Const";
// import ava from "../../assets/avatarprofile.png";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Avatar } from "@mui/material";
import { useSelector } from "react-redux";
import { images } from "../../common/Images";
import { toast, ToastContainer } from "react-toastify";
import store from "../../redux/Store";
import $ from "jquery";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DefImg from "../../assets/avatar.png";
// import store from "../../redux/Store";


export const Profileleft = ({}) => {
  const user = useSelector((state) => state.auth.user);
  // const[UserProfile,  setUserProfile] = useState(user.avatar);
  const [updateImage, setUpdatedImage] = useState();
  const navigate = useNavigate();
  const [cusdetails, setCusdetails] = useState({}); 
  const [urlPath, setPath] = useState("myprofile");
  const handleLogOut = () => {
    const logoutParams = { customer_id: user.id,type:"web" };

    ApiCall("auth/logout", logoutParams)
      .then((data) => {
        if (data.message == "Success.") {
          store.dispatch({ type: "logout" });
          store.dispatch({ type: "removeData" });
          store.dispatch({ type: "clearCart" });

          //  localStorage.setItem("access_token","");
          //  localStorage.setItem("customerId", "");
          //  localStorage.setItem("first_name", "");
          localStorage.clear();
          sessionStorage.removeItem("viewedProducts");

          toast.success("Logged out succesfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          navigate("/");
        } else {
          toast.error(data.message, {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
        }
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    profileView();
  }, []);

  const profileView = () => {
    const profileParams = { id: user && user.id };
    ApiCall("profileView", profileParams)
      .then((data) => {
        //  console.log(data);
        if (data.message == "Success.") {
             store.dispatch({ type: "userupdate", payload: data.data });
          setCusdetails(data.data);
        }
      })
      .catch((err) => console.log(err));
  };

  // console.log(cusdetails);

  const updateProfile = (data) => {
    console.log(data);
    const Params = {
      id: user.id,
      // first_name: cusdetails.first_name,
      // last_name: cusdetails.lastName,
      // // email: Email,
      // phone_number: cusdetails.phone_number,
      avatar: data,
    };
    ApiCall("updateProfile", Params)
      .then((data) => {
        profileView();
        if (data.message == "Success.") {
          console.log(data);
        }
      })
      .catch((err) => {
        toast.error("Request Failed, try again!", {
          position: "top-right",
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  };
  const avatorUpload = (e) => {
    console.log(e.target.files[0], "event.target.files[0]");
    setUpdatedImage(e.target.files[0]);

    const input = e.target;
    if (input.files && input.files[0]) {
      // console.log('in')
      var reader = new FileReader();
      reader.onload = async function (e) {
        // console.log(initial_image)
        var splitted = e.target.result.split(",");
        var splitd = splitted[1];
        // console.log(splitd, "fdshvghcdgsplitd");
        FilterApi("avatarUpload", { image: splitd })
          .then((data) => {
            console.log(data);

            // setInitialImage('')
            if (data.message == "Success") {
              updateProfile(data.result);
              toast.success("Profile Successfully Updated", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                limit: 1,
              });
            } else {
              console.log("lksdflds");
              toast.error(data.message, {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
              });
            }
          })
          .catch((err) => console.log(err));
      };
      reader.readAsDataURL(input.files[0]);
    }
  };

  console.log(cusdetails);
  // console.log(user);
  // console.log("werwerwerwerwerwer", initial_image);
    //  var path = window.location.href.split("/");
    //  setPath(path[3]);
    // console.log();
    useEffect(() => {
      var path = window.location.href.split("/");
      setPath(path[3]);
    }, [urlPath]);
  return (
    <div
      className="left col-11 col-sm-3 col-md-3 col-lg-3 col-xl-3 col-xxl-3 p-0"
      style={{
        backgroundColor: Colors.white_color,
        borderRadius: "20px",
        height: "50%",
      }}
    >
      <div className="left-contents d-flex flex-column">
        <div
          className="profile d-flex align-items-center justify-content-between "
          onClick={() => navigate("/myprofile")}
        >
          <div className="d-flex align-items-center avatars">
            {/* <img
                className="avatar rounded-circle img-fluid  "
                src={avatar != " " ? ava : ava}
            
            
              ></img> */}
            <div className="d-flex">
              <Avatar
                alt={user ? user.first_name : ""}
                src={
                  user && user.avatar != ""
                    ? Web_url.Domain_url + cusdetails.avatar
                    : DefImg
                }
                sx={{ width: 56, height: 56 }}
              />
              <IconButton
                color="primary"
                aria-label="upload picture"
                component="label"
              >
                <input
                  hidden
                  accept="image/*"
                  type="file"
                  onChange={avatorUpload}
                />
                <PhotoCamera />
              </IconButton>
            </div>

            <div className="usernames">
              <h5
                style={{
                  marginBottom: "0px",
                  paddingTop: "10px",
                  color: urlPath == "myprofile" ? "#126a38" : "grey",
                  fontWeight: "bold",
                }}
              >
                {user && user.first_name}
              </h5>
              <small>Customer ID:{user && user.id}</small>
            </div>
          </div>
          <img src={arrow} className="arrows"></img>
        </div>
        <hr className="hrcode"></hr>
        <Link to="/myorder" style={{ textDecoration: "none", color: "black" }}>
          <div
            id="myorder"
            className="profile d-flex align-items-center justify-content-between "
          >
            <h5
              className="profilelist"
              style={{
                color: urlPath == "myorder" ? "#126a38" : "grey",
                fontWeight: "bold",
              }}
            >
              My Orders
            </h5>
            <img src={arrow} className="arrows"></img>
          </div>
        </Link>

        <hr className="hrcode"></hr>
        <Link to="/address" style={{ textDecoration: "none", color: "black" }}>
          {" "}
          <div className="profile d-flex align-items-center justify-content-between ">
            <h5
              className="profilelist"
              style={{
                color: urlPath == "address" ? "#126a38" : "grey",
                fontWeight: "bold",
              }}
            >
              Address
            </h5>
            <img src={arrow} className="arrows"></img>
          </div>
        </Link>
        <hr className="hrcode"></hr>
        <div
          className="profile d-flex align-items-center justify-content-between "
          onClick={() => navigate("/terms-use")}
        >
          <h5
            className="profilelist"
            style={{
              color: urlPath == "term&condition" ? "#126a38" : "grey",
              fontWeight: "bold",
            }}
          >
            Terms & Conditions
          </h5>
          <img src={arrow} className="arrows"></img>
        </div>
        <hr className="hrcode"></hr>
        <div
          className="profile d-flex align-items-center justify-content-between "
          onClick={() => navigate("/privacy-policy")}
        >
          <h5
            className="profilelist"
            style={{
              color: urlPath == "privacy_policy" ? "#126a38" : "grey",
              fontWeight: "bold",
            }}
          >
            Privacy Policy
          </h5>
          <img src={arrow} className="arrows"></img>
        </div>        
      </div>
      <div style={{background:Colors.Base_color}}
          className="profile logout-btn d-flex align-items-center justify-content-between mt-2 py-3"
          data-bs-toggle="modal"
          data-bs-target="#logout"
        >
          <h5 className="profilelist mb-0">Log Out</h5>
          <img src={arrow} className="arrows left-contents"></img>
        </div>
      <div
        class="modal fade"
        id="logout"
        tabindex="-1"
        aria-labelledby="logoutModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <button
                type="button"
                class="btn-close"
                id="closed"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="modal-body">
              <span
                className="d-flex justify-content-center"
                style={{ color: "#126a38", fontSize: "1.2rem" }}
              >
                Are you sure want to logging out?
              </span>
            </div>
            <div className="modal-footer d-flex justify-content-center gap-3">
              <button
                type="button"
                class="btn"
                id="closed"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  color: "white",
                  backgroundColor: "#126a38",
                  fontFamily: "AvenirLTStdMedium",
                  width: "20%",
                }}
                onClick={handleLogOut}
              >
                Yes
              </button>
              <button
                type="button"
                class="btn "
                data-bs-dismiss="modal"
                style={{
                  color: "white",
                  backgroundColor: "#126a38",
                  fontFamily: "AvenirLTStdMedium",
                  width: "20%",
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer />
    </div>
  );
};
export default Profileleft;
